import { render, staticRenderFns } from "./Create-Part.vue?vue&type=template&id=6016a011"
import script from "./Create-Part.vue?vue&type=script&lang=js"
export * from "./Create-Part.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports